module.exports = __webpack_public_path__ + "img/profesional-icon.a032088f.png";